'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _button = require('../button');

var _icon = require('../icon');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _data = require('../util/data');

var _util3 = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * tab页签切换
 */
var Tabs = (_temp = _class = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tabs).call(this, props));

    _this._clickHandler = function (code) {
      // 如果通过 props 里的 activeKey 传入进来, 通过 willReceiveProps 去变更 state
      if (!('activeKey' in _this.props)) {
        _this.setState({ activeKey: code });
      } else {
        var onChange = _this.props.onChange;

        onChange && onChange(code);
      }
    };

    if ('value' in props) {
      //console.warn('请使用 Tabs 的属性 data 代替 value');
    }
    var activeKey = props.activeKey;
    var model = props.model;

    _this.model = Object.assign({}, _util3.MODEL, model);
    _this.state = {
      activeKey: activeKey || ''
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var defaultActiveKey = this.props.defaultActiveKey;

      var value = this.getRenderValue(this.props);
      var activeKey = this.state.activeKey;

      if ((0, _data.isEmptyString)(activeKey)) {
        (function () {
          //如果没有传入的activeKey 或者 activeKey 不在 value 里，默认展示第一个tab页签
          activeKey = defaultActiveKey || '';
          var idField = _this2.model.idField;

          if (value && value.length > 0 && !value.some(function (v) {
            return v[idField] === activeKey;
          })) {
            activeKey = value[0] && value[0][idField];
          }
          _this2.setState({ activeKey: activeKey });
        })();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var activeKey = this.state.activeKey;

      if (nextProps.hasOwnProperty('activeKey')) {
        activeKey = nextProps.activeKey || '';
      }
      var value = this.getRenderValue(nextProps);
      var idField = this.model.idField;

      if (value && value.length > 0 && !value.some(function (v) {
        return v[idField] === activeKey;
      })) {
        activeKey = value[0] && value[0][idField];
      }
      this.setState({ activeKey: activeKey });
    }
  }, {
    key: 'getRenderValue',
    value: function getRenderValue(props) {
      return props.data || props.value || [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var activeKey = this.state.activeKey;
      var _props = this.props;
      var type = _props.type;
      var size = _props.size;
      var prefixCls = _props.prefixCls;
      var position = _props.position;
      var width = _props.width;
      var height = _props.height;
      var style = _props.style;
      var className = _props.className;

      var value = this.getRenderValue(this.props);
      var model = this.model;
      prefixCls += "-tabs";
      var sizeCls = {
        large: 'lg',
        small: 'sm'
      }[size] || '';
      var cls = (0, _classnames2.default)(className, '' + prefixCls, prefixCls + '--' + type, prefixCls + '--' + position, (_classNames = {}, _defineProperty(_classNames, prefixCls + '--' + sizeCls, sizeCls), _defineProperty(_classNames, prefixCls + '--height', height), _classNames));
      style = Object.assign({}, style, width && { width: (0, _util3.getSizeValue)(width) }, height && { height: (0, _util3.getSizeValue)(height) });
      return _react2.default.createElement(
        'div',
        { className: cls, style: style },
        _react2.default.createElement(TabsBar, _extends({ ref: 'tabsBar' }, this.props, {
          prefixCls: prefixCls,
          activeKey: activeKey,
          model: model,
          value: value,
          size: size,
          onChange: this._clickHandler })),
        _react2.default.createElement(TabsContent, _extends({}, this.props, { prefixCls: prefixCls,
          activeKey: activeKey,
          model: model,
          value: value }))
      );
    }
  }]);

  return Tabs;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  type: _propTypes2.default.string,
  activeKey: _propTypes2.default.any,
  defaultActiveKey: _propTypes2.default.any,
  size: _propTypes2.default.oneOf(['default', 'small', 'large']),
  disabled: _propTypes2.default.bool,
  deleteIcon: _propTypes2.default.bool,
  showPage: _propTypes2.default.bool,
  autoDestory: _propTypes2.default.bool,
  initAll: _propTypes2.default.bool,
  position: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  model: _propTypes2.default.shape({
    idField: _propTypes2.default.string,
    showField: _propTypes2.default.string,
    iconField: _propTypes2.default.string,
    deleteIcon: _propTypes2.default.string,
    disableField: _propTypes2.default.string,
    contentField: _propTypes2.default.string
  }),
  value: _propTypes2.default.arrayOf(_propTypes2.default.object),
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  extraTab: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onPrevClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt', // 样式前缀
  type: 'default', // tab 的样式类型 可选 `default` `card` 或者自定义
  defaultActiveKey: '', // 默认选中的 tab 的 [idField]
  disabled: false, // 是否禁用
  deleteIcon: false, // 是否显示删除按钮
  showPage: true, // 是否分页
  initAll: false, // 是否第一次就挂载所有tab的内容
  autoDestory: false, // 是否自动移除未选中tab的内容, 如果 initAll 为 true, 则此属性不生效
  size: 'default', // 大小
  position: 'top', // 页签位于内容的什么位置
  height: '', // 组件的高度
  width: '', // 组件的宽度
  model: {}, // 关键属性名的配置
  extraTab: null, // 额外的标签显示
  onChange: null, // 切换 tab 后触发的事件
  onDelete: _data.noop, // 点击图标后触发的事件
  onPrevClick: _data.noop, // 左切页触发事件
  onNextClick: _data.noop }, _temp);

/**
 * tab 切页标签
 *  每一次点击标签,都需要使active的标签可见
 *  左右箭头切换
 */

var TabsBar = (_temp2 = _class2 = function (_M$BaseComponent) {
  _inherits(TabsBar, _M$BaseComponent);

  function TabsBar(props) {
    _classCallCheck(this, TabsBar);

    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(TabsBar).call(this, props));

    _this3._clickHandler = function (code) {
      var onChange = _this3.props.onChange;
      var activeKey = _this3.state.activeKey;

      if (code !== activeKey) {
        onChange && onChange(code);
      } else {
        _this3.scrollToTab();
      }
    };

    _this3._deleteHandler = function (code, item, btn, e) {
      e.stopPropagation();
      var onDelete = _this3.props.onDelete;

      onDelete && onDelete(code, item, btn, e);
    };

    _this3._pageChangeHandler = function (type) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return new Promise(function ($return, $error) {
        var _state = this.state;
        var _state$scrollPage = _state.scrollPage;
        var scrollPage = _state$scrollPage === undefined ? {} : _state$scrollPage;
        var _state$scrollPage2 = _state.scrollPage;
        var _state$scrollPage2$pa = _state$scrollPage2.pageWidth;
        var pageWidth = _state$scrollPage2$pa === undefined ? 0 : _state$scrollPage2$pa;
        var _state$scrollPage2$tr = _state$scrollPage2.translate;
        var translate = _state$scrollPage2$tr === undefined ? 0 : _state$scrollPage2$tr;

        if (type === 'prev' ? !(0, _util3.hasPrev)(scrollPage) : !(0, _util3.hasNext)(scrollPage)) {
          // 如果没有前/后一页了
          return $return();
        }
        var _props2 = this.props;
        var onPrevClick = _props2.onPrevClick;
        var onNextClick = _props2.onNextClick;

        var confirmHandler = type === 'prev' ? onPrevClick : onNextClick;
        return Promise.resolve(new Promise(function ($return, $error) {
          if (confirmHandler) {
            return Promise.resolve(confirmHandler.apply(undefined, args)).then($return, $error);
          }

          return $return(true);
        }.$asyncbind(this))).then(function ($await_4) {
          var res = $await_4;
          if (!(0, _data.isEmptyString)(res) && !res) {
            return $return();
          }
          pageWidth = this._getPageWidth();
          // 最后一页, 注意下所剩内容区域
          translate = (type !== 'prev' ? _util3.getScrollRight : _util3.getScrollLeft)(scrollPage, pageWidth);

          var _getActiveRect = this._getActiveRect();

          var offsetLeft = _getActiveRect.offsetLeft;
          var offsetWidth = _getActiveRect.offsetWidth;

          this.setState({
            scrollPage: Object.assign({}, scrollPage, { translate: translate, pageWidth: pageWidth }),
            inkBar: { translate: offsetLeft + translate, width: offsetWidth }
          });
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(_this3));
    };

    _this3._getPageWidth = function () {
      return _this3.refs.nav && _this3.refs.nav[_this3.position.offsetWidth] - _this3.padding * 2;
    };

    _this3._getTransform = function (translate) {
      return (0, _util3.isVertical)(_this3.props.position) ? 'translate3d(0px, ' + +translate + 'px, 0px' : 'translate3d(' + +translate + 'px, 0px, 0px)';
    };

    _this3._getActiveRect = function () {
      if (!_this3.refs.nav) return {};
      var _this3$position = _this3.position;
      var OW = _this3$position.offsetWidth;
      var OL = _this3$position.offsetLeft;

      var _ref = _this3.refs.nav.querySelector('li.active') || {};

      var offsetLeft = _ref[OL];
      var offsetWidth = _ref[OW];

      return { offsetLeft: offsetLeft, offsetWidth: offsetWidth };
    };

    _this3.resizeClc = function (prevPosition) {
      // 计算前后切换的参数
      var _this3$props = _this3.props;
      var showPage = _this3$props.showPage;
      var position = _this3$props.position;
      var extraTab = _this3$props.extraTab;

      if (!showPage) {
        return;
      }
      var _this3$refs = _this3.refs;
      var $nav = _this3$refs.nav;
      var $extra = _this3$refs.extra;
      var $container = _this3$refs.container;
      var $tabBar = _this3$refs.tabBar;
      var _this3$position2 = _this3.position;
      var OW = _this3$position2.offsetWidth;
      var OL = _this3$position2.offsetLeft;
      var SW = _this3$position2.scrollWidth;
      var WIDTH = _this3$position2.width;

      if (!$nav) {
        return;
      }
      if (extraTab && $extra) {
        // 当有额外 tab 并且要显示左右箭头时, 计算标签页实际可以占据的空间
        var delta = $container[OW] - $extra[OW];
        if (delta < $nav[SW]) {
          $tabBar.style[WIDTH] = delta + 'px';
        }
      }
      // 把页签的宽度重置, 避免从横竖向转换时显示错误
      if ((0, _util3.isVertical)(prevPosition) !== (0, _util3.isVertical)(position)) {
        $tabBar.style[(0, _util3.isVertical)(position) ? 'width' : 'height'] = 'auto';
      }
      var scrollWidth = $nav[SW];
      var offsetWidth = $nav[OW];

      if (scrollWidth > offsetWidth) {
        (function () {
          // 如果超长了, 就显示前后箭头

          var _ref2 = _this3.state.scrollPage || {};

          var _ref2$translate = _ref2.translate;
          var translate = _ref2$translate === undefined ? 0 : _ref2$translate;

          _this3.setState({ scrollPage: {} }, function () {
            scrollWidth = $nav[SW];
            var viewable = offsetWidth - _this3.padding * 2; // 原可视区间 - 前后箭头占宽/高
            var pageSize = Math.ceil(scrollWidth / viewable);
            Object.assign(_this3.state, { scrollPage: {
                padding: _this3.padding,
                totalWidth: scrollWidth,
                pageWidth: viewable,
                pageSize: pageSize,
                translate: translate
              } });
            _this3.scrollToTab(true);
          });
        })();
      } else {
        _this3.setState({ scrollPage: null }, _this3.scrollToTab);
      }
    };

    _this3.scrollToTab = function (force) {
      if (!_this3.props.showPage) {
        return;
      }
      var $nav = _this3.refs.nav;

      if (!$nav) return;

      var _this3$_getActiveRect = _this3._getActiveRect();

      var offsetLeft = _this3$_getActiveRect.offsetLeft;
      var offsetWidth = _this3$_getActiveRect.offsetWidth;

      if (offsetWidth === undefined) {
        // 如果没有被选中的标签页
        force && _this3.forceUpdate();
        return;
      }
      if (!_this3.state.scrollPage) {
        // 已经没有超长, 只需要定位下高亮条就可以
        _this3.setState({ inkBar: { translate: offsetLeft, width: offsetWidth } });
        return;
      }
      var _this3$state = _this3.state;
      var _this3$state$scrollPa = _this3$state.scrollPage;
      var scrollPage = _this3$state$scrollPa === undefined ? {} : _this3$state$scrollPa;
      var _this3$state$scrollPa2 = _this3$state.scrollPage;
      var _this3$state$scrollPa3 = _this3$state$scrollPa2.pageWidth;
      var pageWidth = _this3$state$scrollPa3 === undefined ? 0 : _this3$state$scrollPa3;
      var _this3$state$scrollPa4 = _this3$state$scrollPa2.translate;
      var translate = _this3$state$scrollPa4 === undefined ? 0 : _this3$state$scrollPa4;

      pageWidth = _this3._getPageWidth();
      var newTranslate = translate;
      // offsetLeft 包括了 padding-left 的宽度, 而 translate 不包括
      var _offsetLeft = offsetLeft - _this3.padding;
      if (_offsetLeft < -translate) {
        // 如果部分左侧不可视
        newTranslate = (0, _util3.getScrollLeft)(scrollPage, offsetWidth - (_offsetLeft + offsetWidth - -translate));
      } else if (_offsetLeft + offsetWidth > -translate + pageWidth) {
        // 如果部分右侧不可视
        newTranslate = (0, _util3.getScrollRight)(scrollPage, _offsetLeft + offsetWidth - -translate - pageWidth);
      } else {
        // 如果不需要左右滚动, 直接定位
        _this3.setState({ inkBar: { translate: offsetLeft + translate, width: offsetWidth } });
        return;
      }
      if (force || newTranslate !== translate) {
        _this3.setState({
          scrollPage: Object.assign({}, scrollPage, { pageWidth: pageWidth, translate: newTranslate }),
          inkBar: { translate: offsetLeft + newTranslate, width: offsetWidth }
        });
      }
    };

    _this3.state = {
      activeKey: props.activeKey,
      value: props.value,
      inkBar: {}, // 选中的tab的下划线的定位, 宽度
      scrollPage: null };
    _this3.position = (0, _util3.getPositionMap)(props.position);
    _this3.padding = _util3.PADDING[props.size];
    return _this3;
  }

  _createClass(TabsBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state2 = this.state;
      var activeKey = _state2.activeKey;
      var value = _state2.value;

      var handler = void 0;
      if (nextProps.hasOwnProperty('activeKey')) {
        activeKey = nextProps.activeKey;
        handler = this.scrollToTab;
      }
      if (nextProps.size !== this.props.size) {
        this.padding = _util3.PADDING[nextProps.size];
        handler = this.resizeClc;
      }
      if (nextProps.position !== this.props.position) {
        this.position = (0, _util3.getPositionMap)(nextProps.position);
        handler = this.resizeClc.bind(this, this.props.position);
      }
      var _props3 = this.props;
      var _props3$model = _props3.model;
      var model = _props3$model === undefined ? {} : _props3$model;
      var _props3$model2 = _props3.model;
      var idField = _props3$model2.idField;
      var contentField = _props3$model2.contentField;
      // 标签页的配置变了, 重新计算宽度

      if (nextProps.value.length !== value.length || nextProps.value.some(function (v) {
        var item = value.find(function (x) {
          return x[idField] === v[idField];
        });
        return !item || Object.keys(item).some(function (p) {
          return p !== contentField && item[p] !== v[p];
        });
      })) {
        value = nextProps.value;
        handler = this.resizeClc;
      }
      this.setState({ value: value, activeKey: activeKey }, handler);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resizeClc();
      this.windowEventListener('resize', this.resizeClc, false);
    }

    // tab 点击响应事件

    // 图标点击响应事件

    /**
     * 超长tab的左右切换
     * @param type 向左或向右切页
     */

    /**
     * 获得最新的每页宽度
     * 由于滚动条的出现, 可能造成宽度的变化, 避免算的不精准
     */

    // 获取transform配置

    // 获取当前被选中页签的DOM属性

  }, {
    key: 'render',
    value: function render() {
      var _classNames2,
          _classNames3,
          _this4 = this;

      var _props4 = this.props;
      var prefixCls = _props4.prefixCls;
      var model = _props4.model;
      var position = _props4.position;
      var extraTab = _props4.extraTab;
      var extraRight = _props4.extraRight;
      var size = _props4.size;
      var itemClass = _props4.itemClass;
      var _state3 = this.state;
      var scrollPage = _state3.scrollPage;
      var inkBar = _state3.inkBar;
      var value = _state3.value;
      var activeKey = _state3.activeKey;

      size = size === 'small' ? "xsmall" : size;

      var _ref3 = scrollPage || {};

      var translate = _ref3.translate;

      var _ref4 = model || {};

      var idField = _ref4.idField;
      var showField = _ref4.showField;
      var iconField = _ref4.iconField;
      var disableField = _ref4.disableField;
      var deleteIconField = _ref4.deleteIconField;

      var navPrefixCls = prefixCls + "__nav";
      var outCls = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '__tabBar-container', true), _defineProperty(_classNames2, prefixCls + '__tabBar-container-extra', extraTab), _defineProperty(_classNames2, prefixCls + '__tabBar-container-extraRight', extraRight), _classNames2));
      var cls = (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, prefixCls + '__tabBar', true), _defineProperty(_classNames3, prefixCls + '__tabBar-scroll', scrollPage), _classNames3));
      var content = [];
      (value || []).forEach(function (item, k) {
        var _classNames4;

        var _ref5 = item || {};

        var code = _ref5[idField];
        var label = _ref5[showField];
        var icon = _ref5[iconField];
        var itemDisabled = _ref5[disableField];
        var itemDeleteIcon = _ref5[deleteIconField];
        var className = _ref5.className;
        var style = _ref5.style;

        var deleteIcon = itemDeleteIcon || _this4.props.deleteIcon;
        var disabled = _this4.props.disabled || itemDisabled;
        var liCls = (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, navPrefixCls + '-item', true), _defineProperty(_classNames4, className, className), _defineProperty(_classNames4, 'active', code === activeKey), _defineProperty(_classNames4, 'no-icon', !icon && !deleteIcon), _defineProperty(_classNames4, 'disabled', disabled), _classNames4), (0, _data.isFunction)(itemClass) ? itemClass(item, k) : itemClass);
        content.push(_react2.default.createElement(
          'li',
          { key: code + k, className: liCls, style: style, onClick: disabled ? _data.noop : _this4._clickHandler.bind(_this4, code) },
          _react2.default.createElement(
            'div',
            { className: navPrefixCls + '-item-title' },
            icon && _react2.default.createElement(_icon.Icon, { type: icon }),
            (0, _react.isValidElement)(label) ? label : _react2.default.createElement(
              'span',
              null,
              label
            )
          ),
          deleteIcon && _react2.default.createElement(_button.Button, { shape: 'no-outline', size: size, icon: 'cross', className: navPrefixCls + '-item-delete', onClick: disabled ? _data.noop : _this4._deleteHandler.bind(_this4, code, item) })
        ));
      });
      var _position = this.position;
      var NEXT = _position.next;
      var PREV = _position.prev;
      var WIDTH = _position.width;

      return _react2.default.createElement(
        'div',
        { className: outCls, ref: 'container' },
        (0, _util3.isVertical)(position) && extraTab && _react2.default.createElement(
          'div',
          { className: prefixCls + '__extra', ref: 'extra' },
          extraTab
        ),
        _react2.default.createElement(
          'div',
          { className: cls, ref: 'tabBar' },
          _react2.default.createElement('div', { className: prefixCls + '__ink-bar', style: _defineProperty({ transform: this._getTransform(inkBar.translate) }, WIDTH, +inkBar.width + 'px') }),
          scrollPage && _react2.default.createElement(_button.Button, { className: prefixCls + '__prev',
            icon: 'angle-' + PREV,
            shape: 'no-outline',
            size: size,
            disabled: !(0, _util3.hasPrev)(scrollPage),
            onClick: this._pageChangeHandler.bind(this, 'prev') }),
          _react2.default.createElement(
            'ul',
            { ref: 'nav', className: '' + navPrefixCls, style: scrollPage && { transform: this._getTransform(translate) } },
            content
          ),
          scrollPage && _react2.default.createElement(_button.Button, { className: prefixCls + '__next',
            icon: 'angle-' + NEXT,
            shape: 'no-outline',
            size: size,
            disabled: !(0, _util3.hasNext)(scrollPage),
            onClick: this._pageChangeHandler.bind(this, 'next') })
        ),
        !(0, _util3.isVertical)(position) && extraTab && _react2.default.createElement(
          'div',
          { className: prefixCls + '__extra', ref: 'extra' },
          extraTab
        )
      );
    }

    /**
     * 重新计算tab的宽/高度, 判断是否要分页
     * @param prevPosition position变化之前的状态
     */

    // 使选中的 tab 可视

  }]);

  return TabsBar;
}(_util2.default.BaseComponent), _class2.propTypes = {
  itemClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  value: _propTypes2.default.array.isRequired
}, _class2.defaultProps = {
  value: []
}, _temp2);

/**
 * tab 内容
 *  initAll 标识一次性渲染所有的 tab, 否则只渲染展示过的
 */

var TabsContent = function (_Component2) {
  _inherits(TabsContent, _Component2);

  function TabsContent(props) {
    _classCallCheck(this, TabsContent);

    var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(TabsContent).call(this, props));

    var inited = {}; // 存储展示过的标签页
    if (!(0, _data.isEmptyString)(props.activeKey)) {
      inited[props.activeKey] = true;
    }
    _this5.state = {
      inited: inited
    };
    return _this5;
  }

  _createClass(TabsContent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var inited = this.state.inited;

      if (nextProps.hasOwnProperty('activeKey') && !(0, _data.isEmptyString)(nextProps.activeKey)) {
        this.setState({ inited: Object.assign(inited, _defineProperty({}, nextProps.activeKey, true)) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props;
      var prefixCls = _props5.prefixCls;
      var value = _props5.value;
      var model = _props5.model;
      var initAll = _props5.initAll;
      var autoDestory = _props5.autoDestory;
      var activeKey = _props5.activeKey;
      var style = _props5.style;
      var inited = this.state.inited;

      var _ref7 = model || {};

      var idField = _ref7.idField;
      var contentField = _ref7.contentField;

      var itemList = [];
      prefixCls += "__content";
      (value || []).forEach(function (item, k) {
        var _classNames5;

        var _ref8 = item || {};

        var code = _ref8[idField];
        var content = _ref8[contentField];

        var other = _objectWithoutProperties(_ref8, [idField, contentField]);

        var liCls = (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, prefixCls + '-item', true), _defineProperty(_classNames5, 'key_' + code, true), _defineProperty(_classNames5, 'active', code === activeKey), _classNames5));
        var showContent = initAll || (autoDestory || item.autoDestory ? code === activeKey : inited[code]);
        itemList.push(_react2.default.createElement(
          'li',
          { key: code + k, className: liCls },
          showContent && (0, _data.getComponent)(content, _extends({ code: code }, other, { index: k }))
        ));
      });
      return _react2.default.createElement(
        'ul',
        { className: prefixCls, style: style },
        itemList
      );
    }
  }]);

  return TabsContent;
}(_react.Component);

exports.default = Tabs;